const Signup = (props) => {
  return (
    <div>
      <h1>Thank you for signing up to be a volunteer with Paddlefest!</h1>
      <p>Paddlefest’s success is thanks to our amazing team of volunteers.</p>
      <p>
        Whether you’re an individual or a part of a corporate group, you can
        make a huge impact on Paddlefest.
      </p>
      <p>
        This form should not take more than a few minutes. You will recieve an
        email with a copy of all your responses and with other helpful
        information. If you have questions about volunteering, please reach out
        to us at{" "}
        <a href="mailto:info@ohioriverpaddlefest.org">
          info@ohioriverpaddlefest.org
        </a>
      </p>
      <p>
        Your information is kept within Adventure Crew, the nonprofit organizer
        and beneficiary of Paddlefest. We will not sell or distribute anything.
        Please provide us with accurate information so we can contact you about
        your volunteer commitment.
      </p>
      <p>
        <b>
          Click "Next" in the lower right-hand corner to advance to the next
          page of the form
        </b>
        , or select a page in the menu on the left of the screen.
      </p>
    </div>
  );
};

export default Signup;
